module.exports = __webpack_public_path__ + "static/media/discount-voucher.82f89c2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/discount-voucher.svg
// module id = 945
// module chunks = 5